export const project = {
  acceptsSubmissions: "Accepts Submissions",
  editor: {
    adminLabel: "Admin",
    adminPlaceholder: "Search by username",
    adminHelper: "Choose the project admin by username.",
    projectNameRequired: "Enter a project name.",
    adminRequired: "Choose an admin by username.",
    nameAndAdminRequired: "Project name and admin are required.",
    saveFailed: "Failed to save project. Please try again.",
    uploadIconFailed: "Failed to upload project icon. Please try again.",
    uploadPinFailed: "Failed to upload pin designs. Please try again.",
    deleteFailed: "Failed to delete project. Please try again.",
  },
  list: {
    officialTitle: "Overhear projects",
    officialDescription: "Official Overhear catalogue maps, marked with the official flag.",
    wanderResponsesTitle: "Wander response projects",
    wanderResponsesDescription: "Maps that collect reflections for wander packs.",
    workshopMapsTitle: "Workshop map projects",
    workshopMapsDescription: "Shared and invite maps created for workshop sessions.",
    occasionsTitle: "Occasion projects",
    occasionsDescription: "Celebration, memorial, and other occasion maps.",
    publicUserTitle: "Public user projects",
    publicUserDescription: "Projects created by users that are visible to the public.",
    privateUserTitle: "Private user projects",
    privateUserDescription: "Projects created by users that are invite-only.",
  },
  settings: {
    title: "Project Settings",
    projectName: "Project Name",
    projectNamePlaceholder: "Enter project name",
    projectNameTooltip: "The name of the project as it appears to users",
    projectIcon: "Project Icon",
    projectIconTooltip: "The icon image displayed for this project",
    selectIcon: "Select Icon",
    introRecording: "Project Intro Recording",
    introRecordingTooltip: "Optional one-time project intro recording. When set, a listener hears this once before normal per-pin collection starts.",
    introRecordingPlaceholder: "Select a recording",
    introRecordingEmpty: "No recordings found for this project",
    clearIntroRecording: "Clear Intro Recording",
    introRecordingToggle: "Enable Project Intro Recording",
    introRecordingToggleTooltip: "Show and use the project intro recording section in the pin list view.",
    isOfficial: "Official Overhear map",
    isOfficialTooltip: "Show this map in the official Overhear projects list, regardless of who owns it.",
    isResponseEnabled: "Enable Responses",
    isResponseEnabledTooltip: "Allow listeners to provide feedback, comments, or audio responses to recordings",
    isAvailable: "Project Available",
    isAvailableTooltip: "Whether this project is currently available and visible to users",
    availabilityStatus: {
      label: "Project Status",
      availabilityLabel: "Availability",
      live: "Live",
      liveDescription: "Fully available to all users who can access this project",
      comingSoon: "Coming Soon",
      comingSoonDescription: "Anyone can see the project as coming soon. Only invitees can see pins.",
      off: "Off",
      offDescription: "Project is hidden and unavailable to listeners",
    },
    projectStatus: {
      title: "Project Status",
      visibilityLabel: "Visibility",
      public: "Public",
      publicDescription: "Anyone who can reach the project may be affected by the availability setting below",
      private: "Private",
      privateDescription: "Only users you invite can access this project, regardless of availability",
    },
    wanderResponses: {
      badgePackPublic: "Wander pack responses",
      badgeUserPrivate: "Private wander responses",
      packPublicHidden: "Hidden from public catalogues until the first listener reflection is saved. Visibility is managed automatically.",
      packPublicListed: "Listed publicly as this pack’s shared responses map. Visibility is managed automatically.",
      packPublicEmptyHint: "This pack responses project will appear in public catalogues after the first reflection is saved (or merged in).",
      userPrivateHelp: "Making this project public merges its reflections into the pack’s shared responses project and retires this private project.",
      mergeConfirm:
        "Make this private wander project public? All reflections will move into the pack’s shared responses project, and this private project will be removed.",
      mergeSuccess: "Merged into {{projectId}}",
      mergeFailed: "Failed to merge wander project. Please try again.",
    },
    hasUpdates: "Enable Subscriptions",
    hasUpdatesTooltip: "Allow users to subscribe to receive notifications about updates to this project",
    acceptsSubmissions: "Accepts Submissions",
    acceptsSubmissionsTooltip: "Allow listeners to submit their own recordings to be included in the project",
    changes: "Changes",
    errors: {
      noProjectSelected: "No project selected",
      updateProjectNameFailed: "Failed to update project name. Please try again.",
      saveSettingsFailed: "Failed to save settings. Please try again.",
      saveSettingsFailedWithError: "Failed to save settings: {{error}}",
      uploadIconFailed: "Failed to upload project icon. Please try again.",
      saveIntroRecordingFailed: "Failed to save project intro recording. Please try again.",
      emailAlreadyExists: "This email is already in the list",
      saveEmailFailed: "Failed to save email. Please try again.",
      saveChangesFailed: "Failed to save changes. Please try again."
    },
    success: {
      settingsSaved: "Settings saved successfully",
      introRecordingSaved: "Project intro recording saved successfully"
    },
    delete: {
      title: "Delete Project",
      message: "This will permanently delete the project and all associated pins, recordings, audio files, icons, and access records. This action cannot be undone.",
      confirmButton: "Delete Project",
      typeProjectName: "Type \"{{name}}\" to confirm deletion",
    },
    resetDownloads: {
      title: "Download Counts",
      tooltip: "Reset download counts for all recordings in this project. This sets how many times recordings have been collected back to zero.",
      button: "Reset Download Counts",
      confirmTitle: "Reset download counts?",
      confirmMessage: "This will set download counts to zero for every recording in this project. This cannot be undone.",
      episodeNote: "Episode projects share one album across all pins, so this resets the project-wide collection total shown in the pin list.",
      confirmButton: "Yes, reset counts",
      success: "Reset download counts for {{count}} recording(s).",
      none: "No recordings had download counts to reset.",
      failed: "Failed to reset download counts. Please try again."
    }
  }
}
